(function () {
    'ngInject';

    angular.module('app.shared.services').factory('QrAPIService', qrAPIService);

    function qrAPIService(HttpService) {
        function fetchSvgString(data) {
            const url = `/QR/GenerateSvg`;
            return HttpService.post(url, data);
        }

        return {
            fetchSvgString: fetchSvgString
        };
    }
})();
